import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';
import getters from './getters';

export const serviceComputed = {
	...mapState('sqlEditorStore', Object.keys(state)),
	...mapGetters('sqlEditorStore', Object.keys(getters)),
};
export const serviceMethods = {
	...mapActions('sqlEditorStore', Object.keys(actions)),
	...mapMutations('sqlEditorStore', Object.keys(mutations)),
};
